/**
 * Vue Router configuration for Zerv Admin Dashboard
 * Centralized router setup with all routes and configurations
 */

import { createRouter, createWebHistory } from "vue-router";

// Import layouts
const MainLayout = () => import("../layouts/MainLayout.vue");
const BackofficeLayout = () => import("../layouts/BackofficeLayout.vue");

// Import route components
const Login = () => import("../views/Login.vue");
const Dashboard = () => import("../views/Dashboard.vue");
const Chats = () => import("../views/Chats.vue");
const Channels = () => import("../views/Channels.vue");
const Team = () => import("../views/Team.vue");
const Settings = () => import("../views/Settings.vue");
const Integrations = () => import("../views/Integrations.vue");

// Route definitions
const routes = [
  // Main layout routes (public pages)
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "Login - Zerv Admin",
      requiresAuth: false,
    },
  },
  {
    path: "/accept-invite",
    name: "AcceptInvite",
    component: () => import("../views/AcceptInvite.vue"),
    meta: {
      title: "Accept Invitation - Zerv Admin",
      requiresAuth: false,
    },
  },
  // Backoffice layout routes (authenticated pages)
  {
    path: "/",
    component: BackofficeLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          title: "Dashboard - Zerv Admin",
        },
      },
      {
        path: "select-org",
        name: "SelectOrg",
        component: () => import("../views/SelectOrg.vue"),
        meta: {
          title: "Select Organization - Zerv Admin",
        },
      },
      {
        path: "onboarding",
        name: "Onboarding",
        component: () => import("../views/Onboarding.vue"),
        meta: {
          title: "Create Organization - Zerv Admin",
        },
      },
      {
        path: "chats",
        name: "Chats",
        component: Chats,
        meta: {
          title: "Chats - Zerv Admin",
        },
      },
      {
        path: "channels",
        name: "Channels",
        component: Channels,
        meta: {
          title: "Channels - Zerv Admin",
        },
      },
      {
        path: "integrations",
        name: "Integrations",
        component: Integrations,
        meta: {
          title: "Integrations - Zerv Admin",
          requiredRole: ['owner', 'admin'],
        },
      },
      {
        path: "team",
        name: "Team",
        component: Team,
        meta: {
          title: "Team - Zerv Admin",
          requiredRole: ['owner', 'admin'],
        },
      },
      {
        path: "settings",
        name: "Settings",
        component: Settings,
        meta: {
          title: "Settings - Zerv Admin",
        },
      },
      {
        path: "settings/ai",
        name: "AISettings",
        component: () => import("../views/AISettings.vue"),
        meta: {
          title: "AI Settings - Zerv Admin",
          requiredRole: ['owner', 'admin'],
        },
      },
    ],
  },
  // Catch-all route for 404
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    redirect: "/",
  },
];

// Create router instance
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  // Global route configuration
  scrollBehavior(to, from, savedPosition) {
    // Return to saved position or top of page
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

// Page title will be set in guards.js

export default router;
